module.exports = __webpack_public_path__ + "static/media/innocent-thumbnail1.f6106652.png";